var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjImportFile",
        {
          ref: "BjImportFile",
          attrs: { "limit-size": 128 * 1024, "auto-upload": "" },
          on: { importFile: _vm.importFile },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
        },
        [_c("template", { slot: "default" }, [_vm._v("只能上传文件")])],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }